import React, {useContext} from "react";
import styled from "styled-components";
import {ButtonWidget} from "../../../widget/pub/button_widget";
import {useParams} from "react-router-dom";
import {useChallenge} from "../fn/challenge";
import {ArbitrationInterface, ArbitrationProvider} from "../arbitration";
import {checkFn, StatusEnum} from "../../../utils/status_check";


export const AsessmentBottomWidget: React.FC = () => {
    const params = useParams<{ id: string }>();
    const arbitrationModel = useContext<ArbitrationInterface>(ArbitrationProvider);


    const handleChallenge = useChallenge(params.id, arbitrationModel?.claim?.cover_hash || '');
    let _status = arbitrationModel?.claim?.status || '';
    return (<AsessmentStyle>
        <span>Claim {arbitrationModel?.claim?.status}</span>

        <ButtonWidget  onClick={handleChallenge}
                       disable={!(checkFn(StatusEnum.pass, _status) || checkFn(StatusEnum.deny, _status))}
                      bgColor={'#0064FD'} text={'Challenge'} size={{x: 10, y: 40}}/>

    </AsessmentStyle>);
}


const AsessmentStyle = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin: 60px 0 30px 0;

  span {
    font-size: 18px;
    color: #30B29A;
    display: block;
    margin-bottom: 10px;

  }
`
